import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import LoadingState from "../../../components/common/LoadingState";
import ActiveSprintThreadCard from "./ActiveSprintThreadCard";
import ChatThreadRow from "./ChatThreadRow";

export default function ChatThreadsPanel({
  activeSprintThread,
  recentThreads = [],
  loading = false,
  selectedConnectionId = "",
  onOpenThread,
  onOpenPerson,
  onOpenConnections,
}) {
  const hasThreads = Boolean(activeSprintThread || recentThreads.length);

  return (
    <Stack spacing={1.5}>
      {activeSprintThread ? (
        <ActiveSprintThreadCard thread={activeSprintThread} onOpen={onOpenThread} onOpenPerson={onOpenPerson} />
      ) : null}

      <Box
        sx={{
          borderRadius: "8px",
          border: "1px solid rgba(226, 234, 242, 0.96)",
          backgroundColor: "#ffffff",
          p: 1.8,
          boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#14213d", mb: 1.2 }}>
          Conversations
        </Typography>

        {loading ? (
          <LoadingState
            title="Preparing conversations"
            body="Checking active Accountability messages and recent threads."
            rows={4}
            compact
          />
        ) : !hasThreads ? (
          <Stack spacing={1.2} sx={{ py: 2 }}>
            <Typography sx={{ fontWeight: 800, color: "#14213d" }}>
              No conversations yet
            </Typography>
            <Typography variant="body2" sx={{ color: "#718198" }}>
              Start with someone from Connections or find a TrustBud.
            </Typography>
            <Box>
              <Button variant="outlined" onClick={onOpenConnections} sx={{ borderRadius: "8px", textTransform: "none" }}>
                Open Connections
              </Button>
            </Box>
          </Stack>
        ) : recentThreads.length === 0 ? (
          <Stack spacing={0.8} sx={{ py: 2 }}>
            <Typography sx={{ fontWeight: 800, color: "#14213d" }}>
              No other conversations yet
            </Typography>
            <Typography variant="body2" sx={{ color: "#718198" }}>
              The conversation you're in now is pinned above.
            </Typography>
          </Stack>
        ) : (
          <Stack spacing={1.1}>
            {recentThreads.map((thread) => (
              <ChatThreadRow
                key={String(thread.connectionId)}
                thread={thread}
                selected={String(thread.connectionId) === String(selectedConnectionId || "")}
                onClick={onOpenThread}
                onOpenPerson={onOpenPerson}
              />
            ))}
          </Stack>
        )}
      </Box>
    </Stack>
  );
}
